import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router } from '@angular/router';

@Injectable()
export class UserAuthentication {
    private readonly url = 'users';

  constructor(private restangular: Restangular, private router: Router) {
  }

  register(data) {
    return this.restangular.all(this.url.concat('/register')).post(data);
  }

  activateAccount(token) {
    return this.restangular.one(this.url, 'activate').one(token + '/').get();
  }

  signIn(data) {
    return this.restangular.all(this.url.concat('/login')).post(data);
  }

  resetPassword(email) {
    return this.restangular.all(this.url.concat('/forgot-password/')).post({'email': email});
  }

  changePassword(data, token) {
    return this.restangular.all(this.url.concat('/change-password/' + token + '/')).post(data);
  }

  redirectIfLoggedIn() {
    const loggedIn = sessionStorage.getItem('isLoggedIn') || localStorage.getItem('isLoggedIn');
    if (loggedIn) {
      this.router.navigateByUrl('home');
    }
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/service/restAngular/user-authentication.ts